export default __webpack_public_path__ + "static/media/navPointer.707f1691.png";